import React, { useEffect } from "react";
import { Modal, ModalBody } from "reactstrap";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { resetObj } from "../../../store/operator/actions";
import { resetHeaderObj } from "../../../store/header/actions";
import { managerLogoutUser, vgStopConnection } from "../../../store/signalr/actions";
import { setInitialStateManagerPanel } from "../../../store/manager/actions";
import { revalidateAvailability } from "../../../store/availability/actions";

import axios from "axios";

import "./styles.scss";

function ComponentModalLogoutUserInfo() {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const signalr = useSelector((state) => state.SignalR);

  const handleLogout = () => {
    dispatch(managerLogoutUser(false));
  };

  const handleRedirect = () => {
    localStorage.removeItem("authUser");
    localStorage.removeItem("availabilities");
    window.location.href = "/login";
  };

  useEffect(() => {
    if (signalr.logoutEvent) {
      dispatch(resetObj());
      dispatch(resetHeaderObj());
      dispatch(setInitialStateManagerPanel());
      dispatch(revalidateAvailability(null));
      dispatch(vgStopConnection(false));
      delete axios.defaults.headers.common["Authorization"];
    }
  }, [signalr.logoutEvent, dispatch]);

  return (
    <>
      <Modal
        isOpen={signalr.logoutEvent}
        className="modal-logout-user-info"
        onClosed={handleRedirect}
      >
        <ModalBody>
          <h4>{t("Disconnected")}</h4>
          <p>
            {t(
              "You have been logged out by your supervisor"
            )}
          </p>
          <div className="actions">
            <button className="btn btn-primary" onClick={handleLogout}>
              {t("Ok")}
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
}

export default ComponentModalLogoutUserInfo;
